// extracted by mini-css-extract-plugin
module.exports = {"postedBy":"e_iF","postedByDate":"e_jF","mobileView":"e_kF"};